import React from 'react';
import { Input, Button, Tooltip } from '@heroui/react';
import { FilterSelect } from '../../../components/ui';
import { useTranslations } from '../../../contexts/translation.context';
import { WithdrawalsFilters } from '../types';
import { ResetFiltersIc } from '../../../components/icons';

interface FiltersSectionProps {
  filters: WithdrawalsFilters;
  localSearch: string;
  hasActiveFilters: boolean;
  onSearchChange: (value: string) => void;
  onFilterChange: (key: keyof WithdrawalsFilters, value: string) => void;
  onResetFilters: () => void;
}

const FiltersSection: React.FC<FiltersSectionProps> = ({
  filters,
  localSearch,
  hasActiveFilters,
  onSearchChange,
  onFilterChange,
  onResetFilters,
}) => {
  const { t } = useTranslations();

  const statusOptions = [
    { key: 'all', label: t('withdrawal.allStatuses') },
    { key: 'pending', label: t('withdrawal.pending') },
    { key: 'paid', label: t('withdrawal.paid') },
    { key: 'cancel', label: t('withdrawal.cancel') },
  ];

  return (
    <div className="px-[24px] py-[16px] ">
      <div className="flex items-center gap-[16px]">
        {/* Search Input */}
        <Input
          type="text"
          placeholder={t('withdrawal.searchPlaceholder')}
          value={localSearch}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)}
          endContent={
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#71717A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M17.5 17.5L13.875 13.875" stroke="#71717A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          }
          classNames={{
            mainWrapper: "w-[273px]",
            base: "w-[273px]",
            input: "text-sm",
            inputWrapper: "rounded-lg h-[36px] w-[273px]",
          }}
        />

        {/* Status Filter */}
        <FilterSelect
          selectedKey={filters.status}
          onSelectionChange={(value) => onFilterChange('status', value)}
          options={statusOptions}
          placeholder={t('withdrawal.status')}
        />

        {/* Reset Filters Button */}
        {hasActiveFilters && (
          <Tooltip content={t('filters.reset') || 'Сбросить фильтры'} placement="top">
            <Button
              size="sm"
              className="h-[36px] rounded-[8px] !w-[36px] p-0 bg-[#F4F4F5] min-w-[36px]"
              onPress={onResetFilters}
            >
              <ResetFiltersIc />
            </Button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default FiltersSection;
